import React, { useRef, useState } from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'
import { OverlayPanel } from 'primereact/overlaypanel'

import Text from '../../ui/Text'
import { Connector } from '../../common/redux/api/web-api'
import { SConnectorStatusIcon } from '../connector-status'

const SContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    padding-bottom: 3px;
`

const SCurrent = styled.div`
    padding: 8px;
    border-top: 1px solid #dddddd;
`

export type ConnectorChargingInfoProps = {
    connector?: Connector
    className?: ClassName
    style?: React.CSSProperties
}

export function ConnectorChargingInfo({ connector }: ConnectorChargingInfoProps): React.ReactElement {
    const [isConnectorCurrentShown, setIsConnectorCurrentShown] = useState(false)

    const op = useRef<OverlayPanel>(null)
    return (
        <>
            <SContainer>
                <SConnectorStatusIcon className={cn('fa fa-flash')} color="blue" data-testid="status-charging" />
                {connector?.totalConsumptionKwh?.toFixed(1)}
                <span data-testid="consumption">
                    <Text code="lblKWh" />
                </span>
                <SConnectorStatusIcon
                    onClick={(e) => {
                        op.current?.toggle(e)
                    }}
                    className={cn('fa pointer', isConnectorCurrentShown ? 'fa-caret-up' : 'fa-caret-down')}
                />
            </SContainer>
            <OverlayPanel
                ref={op}
                onHide={() => setIsConnectorCurrentShown(false)}
                onShow={() => setIsConnectorCurrentShown(true)}
                pt={{ content: { className: 'p-0' } }}
            >
                <div>
                    <SCurrent>
                        <Text
                            code="lblL1"
                            values={{
                                current1: connector?.current1?.toFixed(1),
                                voltage1: connector?.voltage1?.toFixed(1),
                            }}
                        />
                    </SCurrent>
                    <SCurrent>
                        <Text
                            code="lblL2"
                            values={{
                                current2: connector?.current2?.toFixed(1),
                                voltage2: connector?.voltage2?.toFixed(1),
                            }}
                        />
                    </SCurrent>
                    <SCurrent>
                        <Text
                            code="lblL3"
                            values={{
                                current3: connector?.current3?.toFixed(1),
                                voltage3: connector?.voltage3?.toFixed(1),
                            }}
                        />
                    </SCurrent>
                </div>
            </OverlayPanel>
        </>
    )
}
